export class TicketType {
    name_display: string;
    id:string;
    description:string;
    constructor(name:string, id:string, description:string){
        this.name_display = name;
        this.id = id;
        this.description = description;
    }
  }